import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppThunk } from '../index'
export interface ButtonListState {
  buttonList: Array<string>,
}

const initialState: ButtonListState = {
  buttonList: []
}

export const buttonListSlice = createSlice({
  name: 'buttonList',
  initialState,
  reducers: {
    setButtonListState(state, action: PayloadAction<ButtonListState>) {
      state.buttonList = action.payload.buttonList
    }
  }
})
export const getButtonListAsync = (): AppThunk => async (dispatch, getState) => {
  try {
    return Promise.resolve(true)
  } catch (error) {
    return Promise.reject(false)
  }
}

export default buttonListSlice.reducer

export const { setButtonListState } = buttonListSlice.actions
